var React = require('react');
var firebase = require('../../../firebase');
var toastr = require('toastr');
var when = require('when');

var { fbStorage } = firebase;

var Button = require('react-bootstrap/lib/Button');
var Modal = require('react-bootstrap/lib/Modal');
var Carousel = require('react-bootstrap/lib/Carousel');

var Loading = require('../../Loading');

var Files = React.createClass({

	getInitialState() {
    	return {
    		opened: false,
    		loading: true,
    		media: []
    	};
  	},

  	load: function(key) {
  		var me = this,
  			ref = fbStorage.ref(),
  			promises = [
				ref.child('images/' + key + '/profile.jpg').getDownloadURL(),
				ref.child('images/' + key + '/drivers_license.jpg').getDownloadURL(),
				ref.child('images/' + key + '/vehicle.jpg').getDownloadURL(),
				ref.child('images/' + key + '/vehicle_license.jpg').getDownloadURL()
			];

  		when.all(promises)
		.then((response) => {
			this.setState({ loading: false, media: response});
		}).catch((error) => {
			me.close();

			toastr.error('Não foram encontrados registros relacionados ao entregador solicitado.')
		});
  	},

  	open() {
  		var me = this, courierKey = me.props.rowData.id;

  		me.load(courierKey);
  		
  		this.setState({opened: true});
  	},

  	close() {
  	  this.setState({opened: false});
  	},

	render() {
		var me = this, media = me.state.media;

		let items = media.map((item, index) => {
			return (
				<Carousel.Item key={index}>
					<img width={900} 
						 height={400} 
						 alt="Documentos entregador" 
						 src={item}
						 style={{maxHeight: '400px', maxWidth: '100%'}}
					/>
				</Carousel.Item>
			)
		});

    	return (
    		<div>
	    		<Button 
	    			onClick={me.open}
	    			bsSize="small"
	    			bsStyle="primary">
	    			{"Documentos"}
	    		</Button>
	    		
	    		<Modal show={me.state.opened} onHide={me.close}>
	    			<Loading loading={me.state.loading} />

					<Carousel interval={15000}>
						{items}
					</Carousel>
				</Modal>
	    	</div>
    	);
  	}

});

module.exports = Files;


// WEBPACK FOOTER //
// ./src/components/Admin/Couriers/Files.jsx